import * as Yup from "yup";
import { VALIDATION_KEYS } from '../../utils/translation-constants'
import validationConfig from "custom/config/validation.config.json";
const loanConfig = validationConfig["calculator"]["loan"];
const depositConfig = validationConfig["calculator"]["deposit"];

const validateLoanAmount = loanConfig["isLoanAmountRequired"]
  ? {
    loanAmount: Yup.number().min(1, VALIDATION_KEYS.GREATER_THAN_ZERO).required(VALIDATION_KEYS.LOAN_AMOUNT_REQUIRED),
    }
  : {
      loanAmount: Yup.number().optional(),
    };
const validateLoanTenure = loanConfig["isTenureRequired"]
  ? {
    loanTenure: Yup.number()
    .min(0,VALIDATION_KEYS.LOAN_TENURE_GREATER_EQUAL)
    .required(VALIDATION_KEYS.TENURE_REQUIRED),
    }
  : {
      loanTenure: Yup.number().optional(),
    };
const validateLoanInterestRate = loanConfig["isInterestRateRequired"]
  ? {
    loanInterestRate: Yup.number()
    .min(0, VALIDATION_KEYS.LOAN_INTEREST_RATE_GREATER_EQUAL)
    .required(VALIDATION_KEYS.INTEREST_RATE_REQUIRED),
    }
  : {
      loanInterestRate: Yup.number().optional(),
    };

const validateDepositAmount = depositConfig["isDepositAmountRequired"]
  ? {
    depositAmount: Yup.number().min(1, VALIDATION_KEYS.GREATER_THAN_ZERO).required(VALIDATION_KEYS.DEPOSIT_AMOUNT_REQUIRED),
    }
  : {
      depositAmount: Yup.number().optional(),
    };
const validateDepositTenure = depositConfig["isTenureRequired"]
  ? {
    depositTenure: Yup.number()
    .min(0, VALIDATION_KEYS.DEPOSIT_TENURE_GREATER_EQUAL)
    .required(VALIDATION_KEYS.TENURE_REQUIRED),
    }
  : {
      depositTenure: Yup.number().optional(),
    };
const validateDepositInterestRate = depositConfig["isInterestRateRequired"]
  ? {
    depositInterestRate: Yup.number()
    .min(0, VALIDATION_KEYS.DEPOSIT_INTEREST_RATE_GREATER_EQUAL)
    .required(VALIDATION_KEYS.INTEREST_RATE_REQUIRED),
    }
  : {
      depositInterestRate: Yup.number().optional(),
    };

export const LoanSchema = Yup.object().shape({
  ...validateLoanAmount,
  ...validateLoanTenure,
  ...validateLoanInterestRate,
});

export const DepositSchema = Yup.object().shape({
  ...validateDepositAmount,
  ...validateDepositTenure,
  ...validateDepositInterestRate,
});


